<template>
  <div class="c-page u-relative">
<section    data-color="clear" class="u-relative   u-overflow-h  js-header-panel">
    <div class="o-wrapper--valign u-flex u-flex-fd--column u-w-fit u-viewport-30-h theelitecars-form-Container u-marg-x-auto">
        <div class="o-wrapper--panel u-marg-x-auto "  style="flex-grow:2;">
          <img  :src="imageHeadSrc" class="img-fluid" >
        </div>
   </div>
  </section>
<section   data-color="dark"      class="u-relative   js-header-panel is-active"  >
<div class="o-wrapper--valign  u-fit inspire-Custom-Container u-marg-x-auto u-marg-y-xs35 u-marg-y-sm@sm">
<div class="u-fit-w">
      <div class="t-text--md--bold u-marg-l-sm u-marg-r-sm t-text--md--bold@md u-relative u-pad-y-xs">
        <span class="c-home__section__elitecars_title     u-color--black">Buy A Luxury Car</span>
        <span  class="c-line c-line--x u-absolute u-pos-bl u-bg--gray u-fit-w"></span>
      </div>
</div>
<div class="u-marg-l-sm u-marg-r-sm u-relative">
<div class="u-pad-l-0@lg u-fit-w@sm">
  <div  class="u-relative u-pad-y-md">
    <core-ajax-form inline-template :action="'/api/inspire/cert/'" :content="content">
            <form :enctype="enctype" :method="method"  :action="action" class="js-form">
              <core-ajax :src="action" :method="method" :contentType="enctype" :data="formData" :header="headers" :auto="!1" @on:success="onFormSuccess" @on:error="onFormError" inline-template>
                <div></div>
              </core-ajax >
                 <div class="u-relative u-vacuum u-flex .u-flex-fd--column u-flex-fw--wrap u-flex-jc--space-between">
                   <core-input  :isRequired="!0" :typesent="'text'" :content="content" @on:success="onInputSuccess(0)" @on:error="onInputError(0)"  @on:mounted="onInputMounted" inline-template>
                     <div class="c-footer__input u-relative  u-valign-top u-marg-r-sm u-w2of2 u-w2of2@lg  u-marg-r-0@xs  u-marg-b-md" style="border: 1px solid rgb(204, 204, 204);margin-bottom: 30px;">

                      <select data-v-cdd2fbfc="" type="select" autocomplete="off" name="prxxofn" class="t-input t-text--sm u-relative u-pad-l-md u-fit-w u-fit-h u--color-input"><option data-v-cdd2fbfc="" value="-1">Select A Make</option><option data-v-cdd2fbfc="" value="">Any</option><option data-v-cdd2fbfc="" value="102">Abarth</option><option data-v-cdd2fbfc="" value="103">Alfa Romeo</option><option data-v-cdd2fbfc="" value="104">Aston Martin</option><option data-v-cdd2fbfc="" value="105">Audi</option><option data-v-cdd2fbfc="" value="106">Bentley</option><option data-v-cdd2fbfc="" value="107">BMW</option><option data-v-cdd2fbfc="" value="108">Cadillac</option><option data-v-cdd2fbfc="" value="109">Caterham</option><option data-v-cdd2fbfc="" value="110">Chevrolet</option><option data-v-cdd2fbfc="" value="111">Ferrari</option><option data-v-cdd2fbfc="" value="112">Ford</option><option data-v-cdd2fbfc="" value="113">GMC</option><option data-v-cdd2fbfc="" value="114">Hummer</option><option data-v-cdd2fbfc="" value="115">Infiniti</option><option data-v-cdd2fbfc="" value="116">Jaguar</option><option data-v-cdd2fbfc="" value="117">Jeep</option><option data-v-cdd2fbfc="" value="118">Lamborghini</option><option data-v-cdd2fbfc="" value="119">Land Rover</option><option data-v-cdd2fbfc="" value="120">Lexus</option><option data-v-cdd2fbfc="" value="121">Maserati</option><option data-v-cdd2fbfc="" value="122">McLaren</option><option data-v-cdd2fbfc="" value="123">Mercedes-Benz</option><option data-v-cdd2fbfc="" value="124">Mini</option><option data-v-cdd2fbfc="" value="125">Mitsubishi</option><option data-v-cdd2fbfc="" value="126">Nissan</option><option data-v-cdd2fbfc="" value="127">Opel</option><option data-v-cdd2fbfc="" value="128">Peugeot</option><option data-v-cdd2fbfc="" value="129">Porsche</option><option data-v-cdd2fbfc="" value="130">Rolls Royce</option><option data-v-cdd2fbfc="" value="131">Smart</option><option data-v-cdd2fbfc="" value="132">Tesla</option><option data-v-cdd2fbfc="" value="133">Toyota</option><option data-v-cdd2fbfc="" value="134">Volkswagen</option><option data-v-cdd2fbfc="" value="702">Year</option></select>

                      </div>
                     </core-input>
                     <core-input  :isRequired="!0" :typesent="'text'" :content="content" @on:success="onInputSuccess(1)" @on:error="onInputError(1)"  @on:mounted="onInputMounted" inline-template>
                       <div class="c-footer__input u-relative  u-valign-top u-marg-r-sm u-w2of2  u-w2of2@lg u-marg-r-0@xs  u-marg-b-md" style="border: 1px solid rgb(204, 204, 204);margin-bottom: 30px;">

                           <select name="model"  id="child_selection" autocomplete="off"  placeholder="Certﬁcation number" class="t-input t-text--sm u-relative  u-pad-l-md u-fit-w u-fit-h u--color-input"  @blur="onFocusOut" >
                             <option value="">Select A Model</option>
                             <option value="">Any</option>
                             <option value="h1-hummer">H1</option>
                             <option value="h2">H2</option>
                             <option value="h3">H3</option>
                             <option value="h3t">H3T</option>
                             <option value="hx">HX</option>
                           </select>

                        </div>
                       </core-input>
                     <core-input  :isRequired="false" :typesent="'text'" :content="content" @on:success="onInputSuccess(2)" @on:error="onInputError(2)"  @on:mounted="onInputMounted" inline-template>
                       <div class="c-footer__input u-relative  u-valign-top u-marg-r-sm u-w2of2 u-w2of2@lg u-marg-r-0@xs  u-marg-b-md" style="border: 1px solid rgb(204, 204, 204);margin-bottom: 30px;">
                         <select name="yr" autocomplete="off" placeholder="Certﬁcation number" class="t-input t-text--sm u-relative  u-pad-l-md u-fit-w u-fit-h u--color-input"  @blur="onFocusOut">
                           <option value="">Select A Year</option>
                           <option value="">Any</option>
                           <option value="2019">2019</option>
                           <option value="2018">2018</option>
                           <option value="2017">2017</option>
                           <option value="2016">2016</option>
                           <option value="2015">2015</option>
                           <option value="2014">2014</option>
                           <option value="2013">2013</option>
                           <option value="2012">2012</option>
                           <option value="2011">2011</option>
                           <option value="2010">2010</option>
                           <option value="2009">2009</option>
                           <option value="2008">2008</option>
                           <option value="2007">2007</option>
                           <option value="2006">2006</option>
                           <option value="2005">2005</option>
                           <option value="2004">2004</option>
                           <option value="2003">2003</option>
                           <option value="2002">2002</option>
                           <option value="2001">2001</option>
                           <option value="2000">2000</option>
                           <option value="1998">1998</option>
                           <option value="1995">1995</option>
                           <option value="1992">1992</option>
                           <option value="1985">1985</option>
                           <option value="1975">1975</option>
                           <option value="1972">1972</option>
                           <option value="1970">1970</option>
                           <option value="1965">1965</option>
                           </select>

                         </div>
                       </core-input>
                       <core-input  :isRequired="!0" :typesent="'text'" :content="content" @on:success="onInputSuccess(1)" @on:error="onInputError(1)"  @on:mounted="onInputMounted" inline-template>
                         <div class="c-footer__input u-relative  u-valign-top u-marg-r-sm u-w2of2  u-w2of2@lg u-marg-r-0@xs  u-marg-b-md" style="border: 1px solid rgb(204, 204, 204);margin-bottom: 30px;">
                           <select  autocomplete="off" name="proCCCfl" placeholder="Last name of professional" class="t-input t-text--sm u-relative u-pad-l-md u-fit-w u-fit-h u--color-input"  @blur="onFocusOut" >
                               <option value="">Select Price Range</option>
                               <option value="10K-200K">AED 10K-200K</option>
                               <option value="200K-400K">AED 200K-400K</option>
                               <option value="400K-700K">AED 400K-700K</option>
                               <option value="700K-1M">AED 700K-1M</option>
                               <option value="1M-1.5M">AED 1M-1.5M</option>
                               <option value="above1.5M">AED 1.5M+</option>
                             </select>

                          </div>
                         </core-input>
                       <core-input  :isRequired="false" :typesent="'text'" :content="content" @on:success="onInputSuccess(2)" @on:error="onInputError(2)"  @on:mounted="onInputMounted" inline-template>
                         <div class="c-footer__input u-relative  u-valign-top u-marg-r-sm u-w2of2 u-w2of2@lg u-marg-r-0@xs  u-marg-b-md" style="border: 1px solid rgb(204, 204, 204);margin-bottom: 30px;">

                             <select  autocomplete="off" name="mialage" placeholder="Certﬁcation number" class="t-input t-text--sm u-relative  u-pad-l-md u-fit-w u-fit-h u--color-input"  @blur="onFocusOut"  >
                                 <option value="">Select a Milage</option>
                                 <option value="10000">10000</option>
                                 <option value="20000">20000</option>
                                 <option value="30000">30000</option>
                                 <option value="40000">40000</option>
                                 <option value="50000">50000</option>
                                 <option value="60000">60000</option>
                               </select>

                           </div>
                         </core-input>

                       <div class="c-footer__input u-relative  u-valign-top u-marg-r-sm u-w2of2 u-w2of2@lg u-marg-r-0@xs  u-marg-b-md" >
                         <button  class="c-footer__btn-submit t-btn t-btn--primary t-text--sm u-relative u-bg--brand-Botton-color u-color--white u-pad-x-md" @click="onFormSubmit">SEARCH</button>
                       </div>

                     </div>
                     </form>
          </core-ajax-form>
        </div>
</div>
</div>
</div>
</section>
</div>
</template>
<script>
import      AppScrollObject  from  '../app-scroll-object/index.vue'
import      CoreEmit from     '../core-emit/index.vue'
import      CoreAjaxForm from     '../core-ajax-form/index.vue'
export default {
  name: "app-team-popin",
               props: {
                 debug: {
                   type: Boolean,
                   default: !1
               },
                   content: {
                       type: Object,
                       default: function() {}
                   },
                   isActive: {
                       type: Boolean,
                       default: !1
                   },
                   title: {
                       type: String,
                       default: ""
                   },
                   index: {
                       type: Number,
                       default: 0
                   }
               },
               data: function() {
                   return {
                       buttonHoveredIndex: null,
                       vCardLink: "",
                    //  imageHeadSrc:require('../../../static/HeadImages/buy-theElitecar-carform.jpg')
                   }

               },
               components: {
                   "app-scroll-object":AppScrollObject,
                    "core-emit":CoreEmit,
                     'core-ajax-form':CoreAjaxForm
               },

               watch: {
                   isActive: "onActiveChange"
               },
               created: function()
               {
                   this.onPrintPage = this.onPrintPage.bind(this),
                   this.eventHub.$on("print:page", this.onPrintPage),
                    this.eventHub.$on("close:Panel", this.closePanel)
               },
               mounted: function() {

                             console.log("this is ");
               },
               destroyed: function() {
                   this.eventHub.$off("print:page", this.onPrintPage)
                   this.eventHub.$off("close:Panel", this.closePanel)
               },
               methods: {
                 getRandomNumber: function(min, max) {
                      return Math.floor(Math.random() * (max -min +1)) + min;
                      },
                   onActiveChange: function()
                   {

                       this.$el.querySelector(".toscrollup").scrollTop=0,

                       this.$buttons = this.$el.querySelectorAll(".js-button-hovered"),
                       this.isActive
                       ?
                       (document.addEventListener("keydown", this._onKeydown), this.$el.classList.add("is-visible"))
                       :
                       (document.removeEventListener("keydown", this._onKeydown),  this.$el.classList.remove("is-visible"))
                   },
                   _onKeydown: function(t) {
                       27 === t.keyCode && this.eventHub.$emit("close:popin")
                   },
                   toDataURL: function(t, e)
                   {
                       var n = new XMLHttpRequest;
                       n.onload = function()
                       {
                           var t = new FileReader;
                           t.onloadend = function() {
                               e(t.result)
                           }, t.readAsDataURL(n.response)
                       }, n.open("GET", t), n.responseType = "blob", n.send()
                   },
                   onPrintPage: function() {
                       window.print()
                   },
                   _onMouseenterButton: function(t)
                   {
                       0 === t && (this.$buttons[1].style.transform = "translateX(" + (this.$buttons[t].offsetWidth - 1) + "px) translateY(0) translateZ(0)")
                   },
                   _onMouseleaveButton: function(t)
                   {
                       0 === t && (this.$buttons[1].style.transform = "translateX(0) translateY(0) translateZ(0)")
                   },
                   closePanel()
                   {
                     this.$emit('closePanel', {

                     });
                    }
               }
}
</script>
<style scoped>
</style>
